// react
import styled from 'styled-components';

// assets
// @transform-path ../../../../../../src/assets/csat/1.svg
import csat1 from '@/assets/csat/1.svg';
// @transform-path ../../../../../../src/assets/csat/2.svg
import csat2 from '@/assets/csat/2.svg';
// @transform-path ../../../../../../src/assets/csat/3.svg
import csat3 from '@/assets/csat/3.svg';
// @transform-path ../../../../../../src/assets/csat/4.svg
import csat4 from '@/assets/csat/4.svg';
// @transform-path ../../../../../../src/assets/csat/5.svg
import csat5 from '@/assets/csat/5.svg';

interface CSATProps {
  className?: string;
  label?: string;
  onPress?: (value: number) => void;
}

/**
 * CSAT component displays a 5-star rating system.
 */
export const CSAT = ({
  className,
  label = 'How helpful was this?',
  onPress,
}: CSATProps) => {
  return (
    <Wrapper className={className}>
      {label && <LabelContainer>{label}</LabelContainer>}
      <FeedbackOptionGroup>
        <FeedbackOption onClick={() => onPress?.(1)}>
          <img src={csat1} alt='1 out of 5' />
        </FeedbackOption>
        <FeedbackOption onClick={() => onPress?.(2)}>
          <img src={csat2} alt='2 out of 5' />
        </FeedbackOption>
        <FeedbackOption onClick={() => onPress?.(3)}>
          <img src={csat3} alt='3 out of 5' />
        </FeedbackOption>
        <FeedbackOption onClick={() => onPress?.(4)}>
          <img src={csat4} alt='4 out of 5' />
        </FeedbackOption>
        <FeedbackOption onClick={() => onPress?.(5)}>
          <img src={csat5} alt='5 out of 5' />
        </FeedbackOption>
      </FeedbackOptionGroup>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${(props) => props.theme.spacing[12]};
`;

const LabelContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font: ${(props) => props.theme.typography.body.md.regular};
`;

const FeedbackOptionGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${(props) => props.theme.spacing[8]};
  width: 100%;
`;

const size = 40;
const FeedbackOption = styled.div`
  cursor: pointer;
  width: ${size}px;
  height: ${size}px;
  min-width: ${size}px;
  min-height: ${size}px;
  max-width: ${size}px;
  max-height: ${size}px;

  transition-duration: 200ms;
  &:hover {
    transform: scale(1.2);
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

CSAT.displayName = 'CSAT';

export default CSAT;
